










































































































































































































import {Component, Prop} from "vue-property-decorator";
import {mixins} from "vue-class-component";
import {CommonMixin} from "../../../../shared/services/mixin";
import {LadingPaymentType, LadingPickupType} from "@/enums/type";
import moment from "moment";
import {FreightServiceStore} from "../../../freightservices/store";
import {LadingStore} from "../../store";
import {FreightService, Lading} from "@/interfaces/entity";
import {IdMapper} from "@/interfaces/state/base";
import LadingPaymentTypeLabel from "@/modules/ladings/List/components/PaymentTypeLabel.vue";
import {CustomerType} from "@/enums/type/customertype";

@Component({
  name: "LadingPrintBill",
  components: {LadingPaymentTypeLabel},
})
export default class extends mixins(CommonMixin) {
  @Prop({required: true}) readonly ladingId!: string;
  @Prop({type: Boolean, default: false}) readonly hideFee!: boolean;
  @Prop({ default: () => false }) readonly hasDivider!: boolean;
  @Prop({ default: () => false }) readonly showWeight!: boolean;

  LadingPaymentType = LadingPaymentType;
  LadingPickupType = LadingPickupType;
  CustomerType = CustomerType;
  moment = moment;

  get lading(): Lading {
    return LadingStore.data[this.ladingId] || LadingStore.dataCached[this.ladingId];
  }

  get freightServiceData(): IdMapper<FreightService> {
    return FreightServiceStore.data;
  }

  get totalMoney() {
    if (this.lading?.payment === LadingPaymentType.Receiver) {
      return (this.lading?.codMoney || 0) + this.lading?.totalFee;
    } else if (this.lading?.payment === LadingPaymentType.Cash) {
      return this.lading?.codMoney || 0;
    }
    return 0;
  }
}
